/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at Fri Mar 29 2024
 **/

import { SceneLevel, SceneType } from "@/frameworks/libraries/commons";
import { Properties } from "@/frameworks/libraries/properties";
import { SPACE_SCENE_TYPE } from "../commons";

/**
 * @description 서비스 프로세스에 의존되는 Unity의 씬 위치를 결정하기 위한 정보입니다.
 */

export const avatarSettingScene: UserSpaceType = {
	spaceId: "",
	spaceScene: {
		alternativeSpaceMapType: SPACE_SCENE_TYPE.MY_ROOM,
		path: "",
		sceneLevel: SceneLevel.Empty,
		version: "",
		sceneType: {
			//@ts-ignore - BE값과 Unity 타입 missmatch
			type: "",
			typeNumber: SceneType.FittingRoomScene
		}
	}
};

export const myRoomScene = (myRoomID: string): UserSpaceType => {
	return {
		spaceId: myRoomID,
		spaceScene: {
			alternativeSpaceMapType: SPACE_SCENE_TYPE.MY_ROOM,
			path: "",
			sceneLevel: SceneLevel.MyRoom,
			version: "",
			sceneType: {
				//@ts-ignore - BE값과 Unity 타입 missmatch
				type: "",
				typeNumber: SceneType.MyRoomScene
			}
		}
	};
};

export const serviceBaseSceneProcess = (res: {
	lastSpace?: UserSpaceType;
	entrySpace?: UserSpaceType;
	myRoomID: string;
}) => {
	const { lastSpace, entrySpace, myRoomID } = res;
	if (Properties.property?.isUserStartViaSigninPage) {
		if (Properties.property.routerInfo) {
			// 그룹가입 + 로그인
			return Properties.property.routerInfo;
		}

		if (entrySpace) {
			// 로그인
			return entrySpace;
		}
		return avatarSettingScene;
	}

	if (Properties.property.routerInfo) {
		return Properties.property.routerInfo;
	}

	/**
	 * 이동할 위치가 없는 경우 default scene으로 이동
	 */

	if (!lastSpace && !entrySpace) {
		return myRoomScene(myRoomID);
	}

	if (lastSpace) {
		return lastSpace;
	}

	if (entrySpace) {
		return entrySpace;
	}

	return avatarSettingScene;
};
